import { Notification } from "../interfaces/notifications.interfaces";
import { AuthUser } from "../interfaces/user.interfaces";
import { AuthActionTypes, AuthErrors } from "../types/auth.types";

export interface AuthState {
  loading: boolean;
  isAuthenticated: boolean;
  user: AuthUser;
  message: string;
  error: boolean;
  errors: AuthErrors;
  notifications: Notification[];
}

export const AUTH_INITIAL_STATE: AuthState = {
  loading: false,
  isAuthenticated: false,
  user: {
    usuario: "",
    nombre: "",
    apellidos: "",
    email: "",
    fecha_nacimiento: "",
    sexo: "",
    status: "",
    notas: "",
    rol: "",
    id: 0,
    establecimiento_id: "",
    imagen: null,
    creado_por: "",
    edad: 0,
    fecha_nacimiento_formato: "",
    full_name: "",
    avatar_name: "",
    all_permissions: [],
    permissions: [],
    roles: [],
  },
  message: "",
  error: false,
  errors: {
    email: [],
    password: [],
  },
  notifications: [],
};

export const authReducer = (
  state = AUTH_INITIAL_STATE,
  action: AuthActionTypes
): AuthState => {
  switch (action.type) {
    case "login":
    case "restoreSession":
    case "logout":
      return {
        ...state,
        loading: true,
      };
    case "loginSuccess":
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        error: false,
      };
    case "badRequestError":
      return {
        ...state,
        message: action.payload,
        loading: false,
        error: true,
      };
    case "loginError":
      return {
        ...state,
        error: true,
        loading: false,
        errors: action.payload.errors,
        message: action.payload.message,
      };
    case "restoreSessionSuccess":
      return {
        ...state,
        loading: false,
        error: false,
        user: action.payload,
        isAuthenticated: true,
      };
    case "restoreSessionError":
      return {
        ...state,
        loading: false,
        error: false,
        isAuthenticated: false,
      };
    case "logoutSuccess":
      return {
        ...state,
        loading: false,
        error: false,
        isAuthenticated: false,
      };
    case "getNotifications":
    case "getNotificationsError":
      return { ...state };
    case "setNotifications":
    case "getNotificationsSuccess":
      return {
        ...state,
        notifications: action.payload,
      };
    default:
      return state;
  }
};
